import React, { useEffect } from 'react';
import CoreException from './index';
import { sendCustomEvent } from '@utils/volcengine';

const NotFound = function () {
  useEffect(() => {
    sendCustomEvent({
      name: '404',
      categories: {
        detail: `${location.href}未找到`
      }
    });
  }, []);

  return <CoreException type="404" />;
};

export default NotFound;
